import { html } from 'lit';

import { AdVendor } from '@client/core/AdVendor.js';
import { $retailMediaAtom } from '@client/core/atoms/retailMedia.js';
import { triggerRequest } from '@client/retailMedia/index.js';
import {
  AdServer,
  AdSlot,
  type AfsQuery,
  DisplayPlacementId,
  type LayoutType,
  type PlacementId
} from '@schibsted-nmp/advertising-shared';

export class RetailMediaAdVendor extends AdVendor {
  declare placementId: PlacementId;

  /**
   * This data is sent down as a param from the Podium Layout Server, and is used to
   * determine the query to be used for the AFS request. It will be replaced by server values
   * eventually.
   */
  afsQuery?: AfsQuery;

  initialLayoutType?: LayoutType;

  constructor(
    placementId: string,
    afsQuery?: AfsQuery,
    initialLayoutType?: LayoutType
  ) {
    super(AdServer.Afs, placementId as DisplayPlacementId);

    if (afsQuery) this.afsQuery = afsQuery;
    if (initialLayoutType) this.initialLayoutType = initialLayoutType;
  }

  override updated() {
    // do nothing
  }

  override cleanupEvents() {
    // do nothing
  }

  override setupEvents() {
    const placemntId = this.placementId;
    this.cleanupEvents = $retailMediaAtom.subscribe((atom) => {
      if (atom.eventType === 'layout_change') {
        // we don't want to re-fetch when layout changes, only re-render
        return;
      }
      const { searchQuery, categories } = atom;
      triggerRequest(
        placemntId,
        searchQuery,
        categories,
        this.initialLayoutType
      );
    });
  }

  override requestAd() {
    // AFS is triggered by the config event listener, do nothing here
  }

  override render() {
    return html`
      <slot
        name="${AdSlot.fromPlacementId(this.placementId)}"
        id="${this.placementId}"
      ></slot>
    `;
  }
}
